import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from 'src/app/common/confirmation-modal/confirmation-modal.component';


@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private modalService: NgbModal) {}

  open(
    header: string,
    statement: string,
    comfirmButton = 'Confirm',
    cancelButton = 'Cancel',
    isOk = false
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'confirmation-modal',
      centered: true,
    });
    modalRef.componentInstance.header = header;
    modalRef.componentInstance.statement = statement;
    modalRef.componentInstance.comfirmButton = comfirmButton;
    modalRef.componentInstance.cancelButton = cancelButton;
    modalRef.componentInstance.isOk = isOk;

    return modalRef.result;
  }
}
